@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(1_266_235_010)
public val Res.string.ABOUT_PRODUCT_SCREEN_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:ABOUT_PRODUCT_SCREEN_TITLE_FORMAT", "ABOUT_PRODUCT_SCREEN_TITLE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 57),
      ))
    }

@delegate:ResourceContentHash(-108_602_308)
public val Res.string.BARCODE_SCANNER_INSTRUCTION: StringResource by lazy {
      StringResource("string:BARCODE_SCANNER_INSTRUCTION", "BARCODE_SCANNER_INSTRUCTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68, 175),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68, 135),
      ))
    }

@delegate:ResourceContentHash(-1_769_999_741)
public val Res.string.BARCODE_SCANNER_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:BARCODE_SCANNER_SCREEN_TITLE", "BARCODE_SCANNER_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 244, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 236, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204, 60),
      ))
    }

@delegate:ResourceContentHash(191_637_719)
public val Res.string.BLAND_TODAY_GREETING_DEFAULT: StringResource by lazy {
      StringResource("string:BLAND_TODAY_GREETING_DEFAULT", "BLAND_TODAY_GREETING_DEFAULT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 281, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 317, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 313, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 265, 40),
      ))
    }

@delegate:ResourceContentHash(-323_399_519)
public val Res.string.BLAND_TODAY_GREETING_USERNAME_FORMAT: StringResource by lazy {
      StringResource("string:BLAND_TODAY_GREETING_USERNAME_FORMAT", "BLAND_TODAY_GREETING_USERNAME_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 326, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 366, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 362, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306, 56),
      ))
    }

@delegate:ResourceContentHash(-1_267_054_222)
public val Res.string.BLAND_TODAY_MAIN_CONTROL_SECTION: StringResource by lazy {
      StringResource("string:BLAND_TODAY_MAIN_CONTROL_SECTION", "BLAND_TODAY_MAIN_CONTROL_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 387, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 427, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 427, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 363, 56),
      ))
    }

@delegate:ResourceContentHash(1_920_269_140)
public val Res.string.CALI_GREETINGS_1: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_1", "CALI_GREETINGS_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 576, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 612, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 644, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 544, 52),
      ))
    }

@delegate:ResourceContentHash(1_256_427_297)
public val Res.string.CALI_GREETINGS_10: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_10", "CALI_GREETINGS_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 448, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 492, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 496, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 420, 61),
      ))
    }

@delegate:ResourceContentHash(1_794_103_116)
public val Res.string.CALI_GREETINGS_11: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_11", "CALI_GREETINGS_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 510, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 546, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 566, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 482, 61),
      ))
    }

@delegate:ResourceContentHash(-16_631_095)
public val Res.string.CALI_GREETINGS_2: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_2", "CALI_GREETINGS_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 641, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 657, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 717, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 597, 48),
      ))
    }

@delegate:ResourceContentHash(1_831_021_171)
public val Res.string.CALI_GREETINGS_3: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_3", "CALI_GREETINGS_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 702, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 718, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 778, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 646, 60),
      ))
    }

@delegate:ResourceContentHash(319_348_515)
public val Res.string.CALI_GREETINGS_4: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_4", "CALI_GREETINGS_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 763, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 775, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 835, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 707, 52),
      ))
    }

@delegate:ResourceContentHash(-476_697_002)
public val Res.string.CALI_GREETINGS_5: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_5", "CALI_GREETINGS_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 820, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 836, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 904, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 760, 48),
      ))
    }

@delegate:ResourceContentHash(1_765_574_354)
public val Res.string.CALI_GREETINGS_6: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_6", "CALI_GREETINGS_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 881, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 897, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 969, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 809, 64),
      ))
    }

@delegate:ResourceContentHash(1_478_006_584)
public val Res.string.CALI_GREETINGS_7: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_7", "CALI_GREETINGS_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 942, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 966, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1030, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 874, 60),
      ))
    }

@delegate:ResourceContentHash(1_879_670_818)
public val Res.string.CALI_GREETINGS_8: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_8", "CALI_GREETINGS_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 995, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1035, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1103, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 935, 64),
      ))
    }

@delegate:ResourceContentHash(-1_675_071_563)
public val Res.string.CALI_GREETINGS_9: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_9", "CALI_GREETINGS_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1056, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1100, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1172, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1000, 60),
      ))
    }

@delegate:ResourceContentHash(-323_399_519)
public val Res.string.CALI_GREETINGS_USERNAME_FORMAT: StringResource by lazy {
      StringResource("string:CALI_GREETINGS_USERNAME_FORMAT", "CALI_GREETINGS_USERNAME_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1125, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1177, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1253, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1061, 50),
      ))
    }

@delegate:ResourceContentHash(-958_777_856)
public val Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL: StringResource by lazy {
      StringResource("string:CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL", "CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1180, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1232, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1312, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1112, 61),
      ))
    }

@delegate:ResourceContentHash(-217_918_464)
public val Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT: StringResource by lazy {
      StringResource("string:CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT", "CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1242, 172),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1294, 172),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1374, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1174, 148),
      ))
    }

@delegate:ResourceContentHash(1_085_059_715)
public val Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER: StringResource by lazy {
      StringResource("string:CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER", "CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1415, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1467, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1539, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1323, 76),
      ))
    }

@delegate:ResourceContentHash(1_446_439_812)
public val Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL: StringResource by lazy {
      StringResource("string:CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL", "CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1500, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1540, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1620, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1400, 88),
      ))
    }

@delegate:ResourceContentHash(674_956_557)
public val Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT: StringResource by lazy {
      StringResource("string:CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT", "CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1585, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1625, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1709, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1489, 123),
      ))
    }

@delegate:ResourceContentHash(452_435_193)
public val Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL: StringResource by lazy {
      StringResource("string:CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL", "CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1713, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1745, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1849, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1613, 66),
      ))
    }

@delegate:ResourceContentHash(361_169_617)
public val Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT: StringResource by lazy {
      StringResource("string:CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT", "CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1784, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1816, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1904, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1680, 113),
      ))
    }

@delegate:ResourceContentHash(228_320_424)
public val Res.string.CONTENT_MEAL_PLAN_PERSONAL_LABEL: StringResource by lazy {
      StringResource("string:CONTENT_MEAL_PLAN_PERSONAL_LABEL", "CONTENT_MEAL_PLAN_PERSONAL_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1914, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1942, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2014, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1794, 72),
      ))
    }

@delegate:ResourceContentHash(-1_677_671_997)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_ADJUST_PREFERENCES: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_ADJUST_PREFERENCES", "CONTENT_PERSONAL_MEAL_PLAN_ADJUST_PREFERENCES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1995, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2019, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2095, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1867, 77),
      ))
    }

@delegate:ResourceContentHash(-2_038_832_878)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_BACK: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_BACK", "CONTENT_PERSONAL_MEAL_PLAN_BACK", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2081, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2101, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2185, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1945, 51),
      ))
    }

@delegate:ResourceContentHash(2_106_126_761)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_BREAKFAST: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_BREAKFAST", "CONTENT_PERSONAL_MEAL_PLAN_BREAKFAST", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2133, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2149, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2233, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1997, 56),
      ))
    }

@delegate:ResourceContentHash(-410_783_137)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_CUSTOMIZED_BADGE: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_CUSTOMIZED_BADGE", "CONTENT_PERSONAL_MEAL_PLAN_CUSTOMIZED_BADGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2194, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2206, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2298, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2054, 75),
      ))
    }

@delegate:ResourceContentHash(-1_932_976_563)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_DAY_FORMAT: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_DAY_FORMAT", "CONTENT_PERSONAL_MEAL_PLAN_DAY_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2278, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2286, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2382, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2130, 57),
      ))
    }

@delegate:ResourceContentHash(-1_957_927_347)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_DAY_TITLE_FORMAT: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_DAY_TITLE_FORMAT", "CONTENT_PERSONAL_MEAL_PLAN_DAY_TITLE_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2336, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2344, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2440, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2188, 63),
      ))
    }

@delegate:ResourceContentHash(-275_331_619)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_DESCRIPTION: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_DESCRIPTION", "CONTENT_PERSONAL_MEAL_PLAN_DESCRIPTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2400, 614),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2408, 546),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2504, 594),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2252, 494),
      ))
    }

@delegate:ResourceContentHash(1_098_962_197)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_DINNER: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_DINNER", "CONTENT_PERSONAL_MEAL_PLAN_DINNER", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3015, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2955, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3099, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2747, 49),
      ))
    }

@delegate:ResourceContentHash(170_162_561)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_DRINK: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_DRINK", "CONTENT_PERSONAL_MEAL_PLAN_DRINK", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3073, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3005, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3149, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2797, 48),
      ))
    }

@delegate:ResourceContentHash(-1_292_194_476)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_LUNCH: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_LUNCH", "CONTENT_PERSONAL_MEAL_PLAN_LUNCH", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3126, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3054, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3202, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2846, 48),
      ))
    }

@delegate:ResourceContentHash(252_503_276)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_REFRESH: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_REFRESH", "CONTENT_PERSONAL_MEAL_PLAN_REFRESH", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3183, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3107, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3255, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2895, 66),
      ))
    }

@delegate:ResourceContentHash(1_679_605_207)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_SHOPPING_LIST: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_SHOPPING_LIST", "CONTENT_PERSONAL_MEAL_PLAN_SHOPPING_LIST", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3258, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3186, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3338, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2962, 68),
      ))
    }

@delegate:ResourceContentHash(-163_904_497)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_SNACK: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_SNACK", "CONTENT_PERSONAL_MEAL_PLAN_SNACK", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3327, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3259, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3411, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3031, 48),
      ))
    }

@delegate:ResourceContentHash(1_330_248_795)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_TITLE: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_TITLE", "CONTENT_PERSONAL_MEAL_PLAN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3376, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3316, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3464, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3080, 60),
      ))
    }

@delegate:ResourceContentHash(-775_503_175)
public val Res.string.CONTENT_PERSONAL_MEAL_PLAN_TRY_AGAIN: StringResource by lazy {
      StringResource("string:CONTENT_PERSONAL_MEAL_PLAN_TRY_AGAIN", "CONTENT_PERSONAL_MEAL_PLAN_TRY_AGAIN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3437, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3381, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3533, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3141, 56),
      ))
    }

@delegate:ResourceContentHash(-1_244_903_003)
public val Res.string.CONTENT_SHOPPING_LIST_BUTTON: StringResource by lazy {
      StringResource("string:CONTENT_SHOPPING_LIST_BUTTON", "CONTENT_SHOPPING_LIST_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3506, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3454, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3594, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3198, 56),
      ))
    }

@delegate:ResourceContentHash(631_861_769)
public val Res.string.DAILY_TASKS_COMPLETED_TASKS_SECTION: StringResource by lazy {
      StringResource("string:DAILY_TASKS_COMPLETED_TASKS_SECTION", "DAILY_TASKS_COMPLETED_TASKS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3563, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3515, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3655, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3255, 51),
      ))
    }

@delegate:ResourceContentHash(-3_206_474)
public val Res.string.DAILY_TASKS_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:DAILY_TASKS_SCREEN_TITLE", "DAILY_TASKS_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3619, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3567, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3711, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3307, 60),
      ))
    }

@delegate:ResourceContentHash(-988_093_559)
public val Res.string.DAILY_TASKS_TO_DO_TASKS_SECTION: StringResource by lazy {
      StringResource("string:DAILY_TASKS_TO_DO_TASKS_SECTION", "DAILY_TASKS_TO_DO_TASKS_SECTION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3684, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3628, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3784, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3368, 51),
      ))
    }

@delegate:ResourceContentHash(941_517_973)
public val Res.string.ERROR_INVALID_CREDENTIALS: StringResource by lazy {
      StringResource("string:ERROR_INVALID_CREDENTIALS", "ERROR_INVALID_CREDENTIALS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3744, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3680, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3848, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3420, 73),
      ))
    }

@delegate:ResourceContentHash(1_267_630_604)
public val Res.string.FOOD_HISTORY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:FOOD_HISTORY_SCREEN_TITLE", "FOOD_HISTORY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3830, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3770, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3938, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3494, 61),
      ))
    }

@delegate:ResourceContentHash(109_442_373)
public val Res.string.GENERAL_AGE_EIGHTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_EIGHTIES", "GENERAL_AGE_EIGHTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3892, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3836, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4004, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3556, 40),
      ))
    }

@delegate:ResourceContentHash(-504_407_849)
public val Res.string.GENERAL_AGE_FIFTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_FIFTIES", "GENERAL_AGE_FIFTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3937, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3885, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4057, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3597, 39),
      ))
    }

@delegate:ResourceContentHash(-1_138_141_996)
public val Res.string.GENERAL_AGE_FORTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_FORTIES", "GENERAL_AGE_FORTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3981, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3929, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4105, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3637, 39),
      ))
    }

@delegate:ResourceContentHash(-2_009_117_816)
public val Res.string.GENERAL_AGE_NINETIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_NINETIES", "GENERAL_AGE_NINETIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4021, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3973, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4153, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3677, 40),
      ))
    }

@delegate:ResourceContentHash(-668_234_420)
public val Res.string.GENERAL_AGE_SEVENTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_SEVENTIES", "GENERAL_AGE_SEVENTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4062, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4022, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4206, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3718, 41),
      ))
    }

@delegate:ResourceContentHash(-1_061_974_203)
public val Res.string.GENERAL_AGE_SIXTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_SIXTIES", "GENERAL_AGE_SIXTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4104, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4072, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4256, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3760, 39),
      ))
    }

@delegate:ResourceContentHash(-655_285_016)
public val Res.string.GENERAL_AGE_THIRTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_THIRTIES", "GENERAL_AGE_THIRTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4144, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4120, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4300, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3800, 40),
      ))
    }

@delegate:ResourceContentHash(-553_459_686)
public val Res.string.GENERAL_AGE_TWENTIES: StringResource by lazy {
      StringResource("string:GENERAL_AGE_TWENTIES", "GENERAL_AGE_TWENTIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4189, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4169, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4345, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3841, 40),
      ))
    }

@delegate:ResourceContentHash(2_068_613_022)
public val Res.string.GENERAL_AGE_YOUR_AGE: StringResource by lazy {
      StringResource("string:GENERAL_AGE_YOUR_AGE", "GENERAL_AGE_YOUR_AGE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4230, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4218, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4390, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3882, 40),
      ))
    }

@delegate:ResourceContentHash(227_158_144)
public val Res.string.GENERAL_BMI: StringResource by lazy {
      StringResource("string:GENERAL_BMI", "GENERAL_BMI", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4275, 23),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4259, 23),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4435, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3923, 23),
      ))
    }

@delegate:ResourceContentHash(1_565_800_832)
public val Res.string.GENERAL_CALORIES: StringResource by lazy {
      StringResource("string:GENERAL_CALORIES", "GENERAL_CALORIES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4343, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4327, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4503, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3991, 28),
      ))
    }

@delegate:ResourceContentHash(-1_713_889_066)
public val Res.string.GENERAL_CALORIES_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_CALORIES_FORMAT", "GENERAL_CALORIES_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4299, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4283, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4459, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3947, 43),
      ))
    }

@delegate:ResourceContentHash(-1_684_385_530)
public val Res.string.GENERAL_CANCEL: StringResource by lazy {
      StringResource("string:GENERAL_CANCEL", "GENERAL_CANCEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4372, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4356, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4532, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4020, 30),
      ))
    }

@delegate:ResourceContentHash(1_581_631_286)
public val Res.string.GENERAL_CARBO: StringResource by lazy {
      StringResource("string:GENERAL_CARBO", "GENERAL_CARBO", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4407, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4391, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4567, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4051, 29),
      ))
    }

@delegate:ResourceContentHash(1_542_905_480)
public val Res.string.GENERAL_CM_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_CM_LABEL", "GENERAL_CM_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4449, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4433, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4601, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4081, 28),
      ))
    }

@delegate:ResourceContentHash(2_005_053_496)
public val Res.string.GENERAL_CONTINUE: StringResource by lazy {
      StringResource("string:GENERAL_CONTINUE", "GENERAL_CONTINUE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4478, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4462, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4630, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4110, 36),
      ))
    }

@delegate:ResourceContentHash(-1_702_893_161)
public val Res.string.GENERAL_DETAILS: StringResource by lazy {
      StringResource("string:GENERAL_DETAILS", "GENERAL_DETAILS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4511, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4499, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4667, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4147, 35),
      ))
    }

@delegate:ResourceContentHash(631_861_769)
public val Res.string.GENERAL_DONE: StringResource by lazy {
      StringResource("string:GENERAL_DONE", "GENERAL_DONE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4547, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4535, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4703, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4183, 28),
      ))
    }

@delegate:ResourceContentHash(2_115_557_577)
public val Res.string.GENERAL_ERROR_MAX_VALUE: StringResource by lazy {
      StringResource("string:GENERAL_ERROR_MAX_VALUE", "GENERAL_ERROR_MAX_VALUE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4580, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4564, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4736, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4212, 71),
      ))
    }

@delegate:ResourceContentHash(1_043_860_907)
public val Res.string.GENERAL_ERROR_MIN_VALUE: StringResource by lazy {
      StringResource("string:GENERAL_ERROR_MIN_VALUE", "GENERAL_ERROR_MIN_VALUE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4664, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4640, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4824, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4284, 71),
      ))
    }

@delegate:ResourceContentHash(551_794_917)
public val Res.string.GENERAL_FAT: StringResource by lazy {
      StringResource("string:GENERAL_FAT", "GENERAL_FAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4744, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4716, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4912, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4356, 23),
      ))
    }

@delegate:ResourceContentHash(-703_110_147)
public val Res.string.GENERAL_FIBRE: StringResource by lazy {
      StringResource("string:GENERAL_FIBRE", "GENERAL_FIBRE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4772, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4744, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4944, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4380, 29),
      ))
    }

@delegate:ResourceContentHash(-28_478_200)
public val Res.string.GENERAL_FT_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_FT_LABEL", "GENERAL_FT_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4802, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4774, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4974, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4410, 28),
      ))
    }

@delegate:ResourceContentHash(-28_239_872)
public val Res.string.GENERAL_FT_UNIT: StringResource by lazy {
      StringResource("string:GENERAL_FT_UNIT", "GENERAL_FT_UNIT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4831, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4803, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5003, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4439, 27),
      ))
    }

@delegate:ResourceContentHash(-1_201_071_063)
public val Res.string.GENERAL_GENDER_MEN: StringResource by lazy {
      StringResource("string:GENERAL_GENDER_MEN", "GENERAL_GENDER_MEN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4859, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4831, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5031, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4467, 30),
      ))
    }

@delegate:ResourceContentHash(226_940_167)
public val Res.string.GENERAL_GENDER_WOMEN: StringResource by lazy {
      StringResource("string:GENERAL_GENDER_WOMEN", "GENERAL_GENDER_WOMEN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4898, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4870, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5066, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4498, 36),
      ))
    }

@delegate:ResourceContentHash(-202_114_411)
public val Res.string.GENERAL_GOOD_AFTERNOON: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_AFTERNOON", "GENERAL_GOOD_AFTERNOON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4939, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4911, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5103, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4535, 50),
      ))
    }

@delegate:ResourceContentHash(1_310_509_917)
public val Res.string.GENERAL_GOOD_EVENING: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_EVENING", "GENERAL_GOOD_EVENING", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4982, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4962, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5154, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4586, 44),
      ))
    }

@delegate:ResourceContentHash(-178_533_276)
public val Res.string.GENERAL_GOOD_MORNING: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_MORNING", "GENERAL_GOOD_MORNING", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5027, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5011, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5195, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4631, 44),
      ))
    }

@delegate:ResourceContentHash(1_149_585_924)
public val Res.string.GENERAL_GOOD_NIGHT: StringResource by lazy {
      StringResource("string:GENERAL_GOOD_NIGHT", "GENERAL_GOOD_NIGHT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5072, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5056, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5236, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4676, 42),
      ))
    }

@delegate:ResourceContentHash(492_931_926)
public val Res.string.GENERAL_IN_UNIT: StringResource by lazy {
      StringResource("string:GENERAL_IN_UNIT", "GENERAL_IN_UNIT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5115, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5103, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5279, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4719, 27),
      ))
    }

@delegate:ResourceContentHash(338_150_798)
public val Res.string.GENERAL_KG_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_KG_LABEL", "GENERAL_KG_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5143, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5135, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5307, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4747, 28),
      ))
    }

@delegate:ResourceContentHash(1_851_676_942)
public val Res.string.GENERAL_LB_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_LB_LABEL", "GENERAL_LB_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5172, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5164, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5336, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4776, 28),
      ))
    }

@delegate:ResourceContentHash(1_267_411_435)
public val Res.string.GENERAL_LITRES: StringResource by lazy {
      StringResource("string:GENERAL_LITRES", "GENERAL_LITRES", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5201, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5193, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5365, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4805, 30),
      ))
    }

@delegate:ResourceContentHash(1_988_667_772)
public val Res.string.GENERAL_NOW: StringResource by lazy {
      StringResource("string:GENERAL_NOW", "GENERAL_NOW", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5232, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5224, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5396, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4836, 23),
      ))
    }

@delegate:ResourceContentHash(-1_052_833_166)
public val Res.string.GENERAL_OK: StringResource by lazy {
      StringResource("string:GENERAL_OK", "GENERAL_OK", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5260, 22),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5252, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5432, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4860, 22),
      ))
    }

@delegate:ResourceContentHash(1_826_153_148)
public val Res.string.GENERAL_OPEN: StringResource by lazy {
      StringResource("string:GENERAL_OPEN", "GENERAL_OPEN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5283, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5287, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5463, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4883, 28),
      ))
    }

@delegate:ResourceContentHash(1_296_689_088)
public val Res.string.GENERAL_OZ: StringResource by lazy {
      StringResource("string:GENERAL_OZ", "GENERAL_OZ", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5316, 22),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5316, 22),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5492, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4912, 22),
      ))
    }

@delegate:ResourceContentHash(694_608)
public val Res.string.GENERAL_PROTEIN: StringResource by lazy {
      StringResource("string:GENERAL_PROTEIN", "GENERAL_PROTEIN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5339, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5339, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5515, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4935, 35),
      ))
    }

@delegate:ResourceContentHash(-1_372_763_885)
public val Res.string.GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT: StringResource by lazy {
      StringResource("string:GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT", "GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5375, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5379, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5555, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4971, 61),
      ))
    }

@delegate:ResourceContentHash(-611_378_571)
public val Res.string.GENERAL_RELATIVE_DATE_TODAY: StringResource by lazy {
      StringResource("string:GENERAL_RELATIVE_DATE_TODAY", "GENERAL_RELATIVE_DATE_TODAY", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5437, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5445, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5625, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5033, 43),
      ))
    }

@delegate:ResourceContentHash(1_047_613_034)
public val Res.string.GENERAL_RELATIVE_DATE_YESTERDAY: StringResource by lazy {
      StringResource("string:GENERAL_RELATIVE_DATE_YESTERDAY", "GENERAL_RELATIVE_DATE_YESTERDAY", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5481, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5485, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5677, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5077, 51),
      ))
    }

@delegate:ResourceContentHash(-557_081_932)
public val Res.string.GENERAL_SAVE: StringResource by lazy {
      StringResource("string:GENERAL_SAVE", "GENERAL_SAVE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5533, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5533, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5725, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5129, 28),
      ))
    }

@delegate:ResourceContentHash(-398_839_959)
public val Res.string.GENERAL_STEPS: StringResource by lazy {
      StringResource("string:GENERAL_STEPS", "GENERAL_STEPS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5566, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5566, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5762, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5158, 29),
      ))
    }

@delegate:ResourceContentHash(-1_074_926_955)
public val Res.string.GENERAL_SYMPTOM_BLOATING: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_BLOATING", "GENERAL_SYMPTOM_BLOATING", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5600, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5596, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5788, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5188, 44),
      ))
    }

@delegate:ResourceContentHash(846_670_169)
public val Res.string.GENERAL_SYMPTOM_CONSTIPATION: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_CONSTIPATION", "GENERAL_SYMPTOM_CONSTIPATION", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5649, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5645, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5841, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5233, 52),
      ))
    }

@delegate:ResourceContentHash(-1_882_501_719)
public val Res.string.GENERAL_SYMPTOM_EXCESS_GAS: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_EXCESS_GAS", "GENERAL_SYMPTOM_EXCESS_GAS", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5702, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5702, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5894, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5286, 50),
      ))
    }

@delegate:ResourceContentHash(0)
public val Res.string.GENERAL_SYMPTOM_UNKNOWN: StringResource by lazy {
      StringResource("string:GENERAL_SYMPTOM_UNKNOWN", "GENERAL_SYMPTOM_UNKNOWN", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5769, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5757, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5945, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5337, 31),
      ))
    }

@delegate:ResourceContentHash(1_804_211_963)
public val Res.string.GENERAL_TODAY: StringResource by lazy {
      StringResource("string:GENERAL_TODAY", "GENERAL_TODAY", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5801, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5789, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5977, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5369, 29),
      ))
    }

@delegate:ResourceContentHash(-1_599_225_868)
public val Res.string.GENERAL_UNIT_CUP_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_CUP_LABEL", "GENERAL_UNIT_CUP_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5831, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5815, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6015, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5399, 38),
      ))
    }

@delegate:ResourceContentHash(881_250_752)
public val Res.string.GENERAL_UNIT_FL_OZ_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_FL_OZ_LABEL", "GENERAL_UNIT_FL_OZ_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5870, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5854, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6054, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5438, 44),
      ))
    }

@delegate:ResourceContentHash(218_924_864)
public val Res.string.GENERAL_UNIT_GRAM_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_GRAM_LABEL", "GENERAL_UNIT_GRAM_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5915, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5899, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6099, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5483, 35),
      ))
    }

@delegate:ResourceContentHash(-2_128_552_461)
public val Res.string.GENERAL_UNIT_MEAL_LABEL: StringResource by lazy {
      StringResource("string:GENERAL_UNIT_MEAL_LABEL", "GENERAL_UNIT_MEAL_LABEL", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5951, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5935, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6135, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5519, 39),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("ABOUT_PRODUCT_SCREEN_TITLE_FORMAT", Res.string.ABOUT_PRODUCT_SCREEN_TITLE_FORMAT)
  map.put("BARCODE_SCANNER_INSTRUCTION", Res.string.BARCODE_SCANNER_INSTRUCTION)
  map.put("BARCODE_SCANNER_SCREEN_TITLE", Res.string.BARCODE_SCANNER_SCREEN_TITLE)
  map.put("BLAND_TODAY_GREETING_DEFAULT", Res.string.BLAND_TODAY_GREETING_DEFAULT)
  map.put("BLAND_TODAY_GREETING_USERNAME_FORMAT", Res.string.BLAND_TODAY_GREETING_USERNAME_FORMAT)
  map.put("BLAND_TODAY_MAIN_CONTROL_SECTION", Res.string.BLAND_TODAY_MAIN_CONTROL_SECTION)
  map.put("CALI_GREETINGS_1", Res.string.CALI_GREETINGS_1)
  map.put("CALI_GREETINGS_10", Res.string.CALI_GREETINGS_10)
  map.put("CALI_GREETINGS_11", Res.string.CALI_GREETINGS_11)
  map.put("CALI_GREETINGS_2", Res.string.CALI_GREETINGS_2)
  map.put("CALI_GREETINGS_3", Res.string.CALI_GREETINGS_3)
  map.put("CALI_GREETINGS_4", Res.string.CALI_GREETINGS_4)
  map.put("CALI_GREETINGS_5", Res.string.CALI_GREETINGS_5)
  map.put("CALI_GREETINGS_6", Res.string.CALI_GREETINGS_6)
  map.put("CALI_GREETINGS_7", Res.string.CALI_GREETINGS_7)
  map.put("CALI_GREETINGS_8", Res.string.CALI_GREETINGS_8)
  map.put("CALI_GREETINGS_9", Res.string.CALI_GREETINGS_9)
  map.put("CALI_GREETINGS_USERNAME_FORMAT", Res.string.CALI_GREETINGS_USERNAME_FORMAT)
  map.put("CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL", Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_LABEL)
  map.put("CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT", Res.string.CALI_TODAY_CALORIES_DAILY_PROGRESS_INFO_TEXT)
  map.put("CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER", Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_HEADER)
  map.put("CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL", Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_LABEL)
  map.put("CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT", Res.string.CALI_TODAY_OVERALL_DAILY_PROGRESS_INFO_TEXT)
  map.put("CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL", Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_LABEL)
  map.put("CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT", Res.string.CALI_TODAY_STEPS_DAILY_PROGRESS_INFO_TEXT)
  map.put("CONTENT_MEAL_PLAN_PERSONAL_LABEL", Res.string.CONTENT_MEAL_PLAN_PERSONAL_LABEL)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_ADJUST_PREFERENCES", Res.string.CONTENT_PERSONAL_MEAL_PLAN_ADJUST_PREFERENCES)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_BACK", Res.string.CONTENT_PERSONAL_MEAL_PLAN_BACK)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_BREAKFAST", Res.string.CONTENT_PERSONAL_MEAL_PLAN_BREAKFAST)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_CUSTOMIZED_BADGE", Res.string.CONTENT_PERSONAL_MEAL_PLAN_CUSTOMIZED_BADGE)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_DAY_FORMAT", Res.string.CONTENT_PERSONAL_MEAL_PLAN_DAY_FORMAT)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_DAY_TITLE_FORMAT", Res.string.CONTENT_PERSONAL_MEAL_PLAN_DAY_TITLE_FORMAT)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_DESCRIPTION", Res.string.CONTENT_PERSONAL_MEAL_PLAN_DESCRIPTION)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_DINNER", Res.string.CONTENT_PERSONAL_MEAL_PLAN_DINNER)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_DRINK", Res.string.CONTENT_PERSONAL_MEAL_PLAN_DRINK)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_LUNCH", Res.string.CONTENT_PERSONAL_MEAL_PLAN_LUNCH)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_REFRESH", Res.string.CONTENT_PERSONAL_MEAL_PLAN_REFRESH)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_SHOPPING_LIST", Res.string.CONTENT_PERSONAL_MEAL_PLAN_SHOPPING_LIST)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_SNACK", Res.string.CONTENT_PERSONAL_MEAL_PLAN_SNACK)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_TITLE", Res.string.CONTENT_PERSONAL_MEAL_PLAN_TITLE)
  map.put("CONTENT_PERSONAL_MEAL_PLAN_TRY_AGAIN", Res.string.CONTENT_PERSONAL_MEAL_PLAN_TRY_AGAIN)
  map.put("CONTENT_SHOPPING_LIST_BUTTON", Res.string.CONTENT_SHOPPING_LIST_BUTTON)
  map.put("DAILY_TASKS_COMPLETED_TASKS_SECTION", Res.string.DAILY_TASKS_COMPLETED_TASKS_SECTION)
  map.put("DAILY_TASKS_SCREEN_TITLE", Res.string.DAILY_TASKS_SCREEN_TITLE)
  map.put("DAILY_TASKS_TO_DO_TASKS_SECTION", Res.string.DAILY_TASKS_TO_DO_TASKS_SECTION)
  map.put("ERROR_INVALID_CREDENTIALS", Res.string.ERROR_INVALID_CREDENTIALS)
  map.put("FOOD_HISTORY_SCREEN_TITLE", Res.string.FOOD_HISTORY_SCREEN_TITLE)
  map.put("GENERAL_AGE_EIGHTIES", Res.string.GENERAL_AGE_EIGHTIES)
  map.put("GENERAL_AGE_FIFTIES", Res.string.GENERAL_AGE_FIFTIES)
  map.put("GENERAL_AGE_FORTIES", Res.string.GENERAL_AGE_FORTIES)
  map.put("GENERAL_AGE_NINETIES", Res.string.GENERAL_AGE_NINETIES)
  map.put("GENERAL_AGE_SEVENTIES", Res.string.GENERAL_AGE_SEVENTIES)
  map.put("GENERAL_AGE_SIXTIES", Res.string.GENERAL_AGE_SIXTIES)
  map.put("GENERAL_AGE_THIRTIES", Res.string.GENERAL_AGE_THIRTIES)
  map.put("GENERAL_AGE_TWENTIES", Res.string.GENERAL_AGE_TWENTIES)
  map.put("GENERAL_AGE_YOUR_AGE", Res.string.GENERAL_AGE_YOUR_AGE)
  map.put("GENERAL_BMI", Res.string.GENERAL_BMI)
  map.put("GENERAL_CALORIES", Res.string.GENERAL_CALORIES)
  map.put("GENERAL_CALORIES_FORMAT", Res.string.GENERAL_CALORIES_FORMAT)
  map.put("GENERAL_CANCEL", Res.string.GENERAL_CANCEL)
  map.put("GENERAL_CARBO", Res.string.GENERAL_CARBO)
  map.put("GENERAL_CM_LABEL", Res.string.GENERAL_CM_LABEL)
  map.put("GENERAL_CONTINUE", Res.string.GENERAL_CONTINUE)
  map.put("GENERAL_DETAILS", Res.string.GENERAL_DETAILS)
  map.put("GENERAL_DONE", Res.string.GENERAL_DONE)
  map.put("GENERAL_ERROR_MAX_VALUE", Res.string.GENERAL_ERROR_MAX_VALUE)
  map.put("GENERAL_ERROR_MIN_VALUE", Res.string.GENERAL_ERROR_MIN_VALUE)
  map.put("GENERAL_FAT", Res.string.GENERAL_FAT)
  map.put("GENERAL_FIBRE", Res.string.GENERAL_FIBRE)
  map.put("GENERAL_FT_LABEL", Res.string.GENERAL_FT_LABEL)
  map.put("GENERAL_FT_UNIT", Res.string.GENERAL_FT_UNIT)
  map.put("GENERAL_GENDER_MEN", Res.string.GENERAL_GENDER_MEN)
  map.put("GENERAL_GENDER_WOMEN", Res.string.GENERAL_GENDER_WOMEN)
  map.put("GENERAL_GOOD_AFTERNOON", Res.string.GENERAL_GOOD_AFTERNOON)
  map.put("GENERAL_GOOD_EVENING", Res.string.GENERAL_GOOD_EVENING)
  map.put("GENERAL_GOOD_MORNING", Res.string.GENERAL_GOOD_MORNING)
  map.put("GENERAL_GOOD_NIGHT", Res.string.GENERAL_GOOD_NIGHT)
  map.put("GENERAL_IN_UNIT", Res.string.GENERAL_IN_UNIT)
  map.put("GENERAL_KG_LABEL", Res.string.GENERAL_KG_LABEL)
  map.put("GENERAL_LB_LABEL", Res.string.GENERAL_LB_LABEL)
  map.put("GENERAL_LITRES", Res.string.GENERAL_LITRES)
  map.put("GENERAL_NOW", Res.string.GENERAL_NOW)
  map.put("GENERAL_OK", Res.string.GENERAL_OK)
  map.put("GENERAL_OPEN", Res.string.GENERAL_OPEN)
  map.put("GENERAL_OZ", Res.string.GENERAL_OZ)
  map.put("GENERAL_PROTEIN", Res.string.GENERAL_PROTEIN)
  map.put("GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT", Res.string.GENERAL_RELATIVE_DATE_DAYS_AGO_FORMAT)
  map.put("GENERAL_RELATIVE_DATE_TODAY", Res.string.GENERAL_RELATIVE_DATE_TODAY)
  map.put("GENERAL_RELATIVE_DATE_YESTERDAY", Res.string.GENERAL_RELATIVE_DATE_YESTERDAY)
  map.put("GENERAL_SAVE", Res.string.GENERAL_SAVE)
  map.put("GENERAL_STEPS", Res.string.GENERAL_STEPS)
  map.put("GENERAL_SYMPTOM_BLOATING", Res.string.GENERAL_SYMPTOM_BLOATING)
  map.put("GENERAL_SYMPTOM_CONSTIPATION", Res.string.GENERAL_SYMPTOM_CONSTIPATION)
  map.put("GENERAL_SYMPTOM_EXCESS_GAS", Res.string.GENERAL_SYMPTOM_EXCESS_GAS)
  map.put("GENERAL_SYMPTOM_UNKNOWN", Res.string.GENERAL_SYMPTOM_UNKNOWN)
  map.put("GENERAL_TODAY", Res.string.GENERAL_TODAY)
  map.put("GENERAL_UNIT_CUP_LABEL", Res.string.GENERAL_UNIT_CUP_LABEL)
  map.put("GENERAL_UNIT_FL_OZ_LABEL", Res.string.GENERAL_UNIT_FL_OZ_LABEL)
  map.put("GENERAL_UNIT_GRAM_LABEL", Res.string.GENERAL_UNIT_GRAM_LABEL)
  map.put("GENERAL_UNIT_MEAL_LABEL", Res.string.GENERAL_UNIT_MEAL_LABEL)
}
